import { render, staticRenderFns } from "./Instrument.vue?vue&type=template&id=5cf81ade&scoped=true&"
import script from "./Instrument.vue?vue&type=script&lang=js&"
export * from "./Instrument.vue?vue&type=script&lang=js&"
import style0 from "./Instrument.vue?vue&type=style&index=0&id=5cf81ade&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf81ade",
  null
  
)

export default component.exports